/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { AppPromotionMode } from './AppPromotionMode';

export interface DriverProvisionalRegistrationCreateAccountResponse {
    refresh_token?: string;
    registration_hash: string;
    is_new_registration_created: boolean;
    app_promotion?: AppPromotionMode;
}
